import { useState, useRef } from "react";
import { useReactToPrint } from "react-to-print";
import ReceiptPrint from "../ReceiptPrint";
import { PAYMENT_METHOD } from "../../constants/sharedConstans";

const DeliveryReceiptForm = ({ userName, total, onClose }) => {
  const [address, setAddress] = useState("");
  const [cellphone, setCellphone] = useState("");
  const [isPaid, setIsPaid] = useState(true);
  const [paymentMethod, setPaymentMethod] = useState("");
  const [cashAmount, setCashAmount] = useState("");
  const deliveryReceiptRef = useRef();

  const change = cashAmount - total > 0 ? cashAmount - total : 0;

  const isButtonDisabled = () => {
    if (!address.trim()) return true;

    if (!isPaid) {
      if (paymentMethod === null || paymentMethod === undefined) return true;

      if (paymentMethod === PAYMENT_METHOD[0].id) {
        if (!cashAmount || cashAmount < total) return true;
      }
    }

    return false;
  };

  const handlePrint = useReactToPrint({
    content: () => deliveryReceiptRef.current,
  });

  return (
    <>
      <div className="mb-3">
        <div className="mb-3">
          <div>
            <strong>Cliente:</strong> {userName}
          </div>
          <div>
            <strong>Total a pagar:</strong> $
            {new Intl.NumberFormat("es-CL").format(total)}
          </div>
        </div>
        <div className="mb-3">
          <label className="form-label" htmlFor="addressInput">
            Dirección
          </label>
          <input
            type="text"
            className="form-control"
            id="addressInput"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
          />
        </div>
        <div className="mb-3">
          <label htmlFor="cellphoneInput" className="form-label">
            Celular (opcional)
          </label>
          <input
            type="text"
            className="form-control"
            id="cellphoneInput"
            value={cellphone}
            onChange={(e) => setCellphone(e.target.value)}
            placeholder="Ingrese el número de celular"
          />
        </div>
      </div>
      <div className="form-check form-switch mb-3">
        <input
          className="form-check-input"
          type="checkbox"
          role="switch"
          id="isPaidSwitch"
          checked={isPaid}
          onChange={() => setIsPaid(!isPaid)}
        />
        <label className="form-check-label" htmlFor="isPaidSwitch">
          ¿Ya pagó?
        </label>
      </div>
      {!isPaid && (
        <div className="mb-3">
          {PAYMENT_METHOD.map((method, i) => (
            <div className="form-check form-check-inline" key={i}>
              <input
                className="form-check-input"
                type="radio"
                id="cashPayment"
                name="deliveryPayment"
                value={method.id}
                checked={paymentMethod === method.id}
                onChange={() => setPaymentMethod(method.id)}
              />
              <label className="form-check-label" htmlFor="cashPayment">
                {method.name}
              </label>
            </div>
          ))}
          {paymentMethod === PAYMENT_METHOD[0].id && (
            <div className="mt-2">
              <label htmlFor="cashAmountInput" className="form-label">
                Con cuanto paga?
              </label>
              <input
                type="number"
                className="form-control"
                id="cashAmountInput"
                value={cashAmount}
                onChange={(e) => setCashAmount(parseInt(e.target.value))}
              />
              {change > 0 && (
                <div className="mt-1">
                  <span className="fw-bold">Vuelto: </span>
                  {"$" + new Intl.NumberFormat("es-CL").format(change)}
                </div>
              )}
            </div>
          )}
        </div>
      )}
      <button
        className="btn btn-primary w-100"
        disabled={isButtonDisabled()}
        onClick={() => {
          handlePrint();
          onClose();
        }}
      >
        Imprimir Recibo
      </button>
      <div className="d-none">
        <ReceiptPrint
          ref={deliveryReceiptRef}
          userName={userName}
          address={address}
          cellphone={cellphone}
          isPaid={isPaid}
          paymentMethod={paymentMethod}
          cashAmount={cashAmount}
          change={change}
          total={total}
        />
      </div>
    </>
  );
};

export default DeliveryReceiptForm;
